import { useMemo } from 'react';
import { getFieldMap } from '../constants/fieldResource';
import { ALL_CODES } from '../constants/menuResource';

// 读取当前用户角色权限（登录后存储于 localStorage）
const readStored = (key) => {
    try {
        return JSON.parse(localStorage.getItem(key)) || null;
    } catch (e) {
        return null;
    }
};

// 当前登录用户是否为超级管理员（内置角色）
const isAdminUser = () => {
    const info = readStored('user_info');
    if (!info) return false;
    return info.is_admin === true || info.role === '管理员';
};

// 当前用户可见字段集合（黑名单语义；管理员全部可见，不依赖快照）
export function useVisibleFields(listCode) {
    return useMemo(() => {
        const fields = getFieldMap()[listCode] || [];
        if (isAdminUser()) return new Set(fields.map((f) => f.code));
        const hidden = readStored('user_hidden_fields') || {};
        const hiddenSet = new Set(hidden[listCode] || []);
        return new Set(
            fields
                .filter((f) => f.required || !hiddenSet.has(f.code))
                .map((f) => f.code)
        );
    }, [listCode]);
}

// 当前用户菜单/按钮权限集合（管理员实时拥有全部，避免新增功能后需重新登录）
export function usePermCodes() {
    return useMemo(() => {
        if (isAdminUser()) return new Set(ALL_CODES);
        const codes = readStored('user_codes');
        if (codes && Array.isArray(codes)) return new Set(codes);
        return new Set(ALL_CODES);
    }, []);
}

// 判断是否拥有某菜单/按钮权限
export function hasPerm(code) {
    if (isAdminUser()) return true;
    const codes = readStored('user_codes');
    if (codes && Array.isArray(codes)) return codes.includes(code);
    return true;
}
